import styled from 'styled-components';
import { Flex } from 'rebass/styled-components';
import { mediaQueries, variables } from 'shared/styles';
export default styled(Flex).withConfig({
  displayName: "container",
  componentId: "sc-am2120-0"
})(["padding:0;margin:0 auto;max-width:", "px;width:", "px;align-items:center;justify-content:center;@media ", "{max-width:100%;width:", "px;}"], variables.maxWidthLarge, variables.maxWidthLarge, mediaQueries.largeDesktop, variables.maxWidthMed);